import { DocumentNode } from 'graphql';
import {
  KeyOrganizationEngagementReportResult,
  KeyOrganizationClassroomEngagementReportResult,
  User,
  KeyClassroomEngagementStudentResult
} from 'types/schema-generated-types';

export interface ReportParams {
  entityType: ReportEntityType;
  productFamilyCode: ReportProduct;
  entityId: number | null;
  displayBy: string | null;
  viewAs: ReportView;
  dateRange: ReportDateRange;
}

export enum ReportProduct {
  KEY = 'KEY',
  WDT = 'WDT',
  PRM = 'PRM'
}

export enum ReportEntityType {
  DISTRICT = 'district',
  SCHOOL = 'school',
  USER_GROUP = 'user-group',
  USER = 'user',
  CLASSROOM = 'classroom',
  STUDENT = 'student'
}

export enum ReportView {
  TABLE = 'table',
  CHART = 'chart'
}

export enum ReportDisplayBy {
  CHARACTERS = 'characters',
  STUDENTS = 'students'
}

export enum ReportDateRange {
  SEVEN_DAYS = '7-days',
  FOURTEEN_DAYS = '14-days',
  THRITY_DAYS = '30-days',
  THREE_MONTHS = '3-months',
  SIX_MONTHS = '6-months',
  NINE_MONTHS = '9-months',
  ONE_YEAR = '1-years'
}

export enum ChartCardType {
  COUNT = 'COUNT',
  PERCENT = 'PERCENT'
}

export enum ModuleType {
  CAPITALS = 'capitals',
  LOWERCASE = 'lowercase',
  NUMBERS = 'numbers'
}

export enum CharacterErrorType {
  MISSED_STARTING_POINT = 'MissedStartingPoint',
  STARTED_WRONG_WAY = 'StartedWrongWay',
  OUT_OF_BOUNDS = 'OutOfBounds',
  LIFTED_FINGER = 'LiftedFinger',
  REVERSED_DIRECTION = 'ReversedDirection'
}

export interface ReportWorkbook<T> {
  query: DocumentNode;
  async?: boolean;
  isComplete?: (data: T) => boolean;
  worksheets: ReportWorksheet<T>[];
  getEntityName: (data: T) => string;
}

export interface ReportWorksheet<T> {
  name: string;
  parseQueryData: (data: T, reportParams: ReportParams) => any[][];
}

export interface KeyOrganizationExportingData {
  organization: KeyOrganizationEngagementReportResult;
}

export interface KeyOrganizationSchoolsExportingData extends KeyOrganizationExportingData {
  schools: KeyOrganizationEngagementReportResult[];
}

export interface KeyOrganizationClassroomsExportingData extends KeyOrganizationExportingData {
  classrooms: KeyOrganizationClassroomEngagementReportResult[];
}

export interface KeyEducatorExportingDaata {
  user: User;
  classrooms: KeyOrganizationClassroomEngagementReportResult[];
}

export interface KeyClassroomExportingDaata {
  classroom: KeyOrganizationClassroomEngagementReportResult;
  students: KeyClassroomEngagementStudentResult[];
}

export enum AssessmentSubmodulesNames {
  ALL_MODULES = '*',
  MODULE_1_MATH = 'Module 1 - Math',
  MODULE_2_MATH_ELA = 'Module 2 - Math & ELA',
  MODULE_3_ELA = 'Module 3 - ELA'
}

export enum ResponseDataKeys {
  MULTI_PART = 'Multi-Part',
  CONSTRUCT_A_RESPONSE = 'Construct a Response'
}
